export const defaultMenu = {
    public: [],
    operation: [],
}

export default {
    public: [
        {
            title: 'trem.lang.home.0682', //시설·장비 예약
            menus: [
                {
                    title: `trem.lang.home.0010`, //장비예약
                    route: `/home/equip/reserv/list`,
                    menus: [
                        {
                            title: `trem.lang.home.0399`, //서울바이오허브
                            route: `/`,
                            gotoProps : {
                                EQ_ROOM_SKEY: 1,
                                ATTR_SKEY: 1,
                            }
                        },
                        {
                            title: `trem.lang.home.0416`, //서울바이오 혁신커뮤니티센터
                            route: `/`,
                            gotoProps : {
                                EQ_ROOM_SKEY: 1,
                                ATTR_SKEY: 2,
                            }
                        },
                        // 2025.03.04 삭제 요청 - rotbilly
                        // {
                        //     title: `trem.lang.home.0427`, //서울 바이오 산학협력센터
                        //     route: `/`,
                        //     gotoProps : {
                        //         EQ_ROOM_SKEY: 1,
                        //         ATTR_SKEY: 3,
                        //     }
                        // },
                        {
                            title: `trem.lang.home.0431`, //BT-IT융합센터
                            route: `/`,
                            gotoProps : {
                                EQ_ROOM_SKEY: 1,
                                ATTR_SKEY: 4,
                            }
                        },
						{
                            title: `trem.lang.home.1264`, //글로벌센터
                            route: `/`,
                            gotoProps : {
                                EQ_ROOM_SKEY: 1,
                                ATTR_SKEY: 5,
                            }
                        },
                    ],
                },
                // {
                //     title: `trem.lang.home.0691`, //연계 장비 예약
                //     route: `/home/equip/cooperation/list`,
                // },
                 {
                     title: `trem.lang.home.0011`, //시설예약
                     route: `/home/operation/pubFacility/list`,
                 },
                {
                    title: `trem.lang.home.1257`, //반입물품예약
                    route: `/home/operation/carray/list`,
                },
                // {
                //     title: `trem.lang.home.0438`, //예약현황
                //     route: `/`,
                // },
                // {
                //     title: `trem.lang.home.0215`, //상담 신청 현황
                //     route: `/home/operation/counsel/list`,
                // },
                // {
                //     title: 'trem.lang.home.0259', //시작품 의뢰
                //     route: `/home/equip/prototype/list`,
                // },
            ],
        },
        {
            title: 'trem.lang.home.0018', //교육/세미나
            menus: [
                {
                    title: 'trem.lang.home.0012', //교육신청
                    route: `/home/event/list`,
                },
                
            ],
        },
        {
            title: 'trem.lang.home.0017', //공지사항
            menus: [
                {
                    title: 'trem.lang.home.0017', //공지사항
                    route: `/home/board/notice/list`,
                },
                {
                    title: 'trem.lang.home.0692', //규정 및 정책
                    route: `/home/guide/rule`,
                    menus: [
                        {
                            title: 'trem.lang.home.0693', //규정
                            route: `/home/guide/rule`,
                        },
                        // {
                        //     title: 'trem.lang.home.0694', //이용안내
                        //     route: `/home/guide/use`,
                        // },
                    ],
                },
                {
                    title: 'trem.lang.home.0014', //자료실
                    route: `/home/board/reference/list`,
                },
                // {
                //     title: 'trem.lang.home.0386', //회원가입안내
                //     route: `/home/guide/userJoin`,
                // },
                {
                    title: 'Q&A',
                    route: `/home/board/qna/list`,
                },
                {
                    title: 'FAQ',
                    route: `/home/board/faq/list`,
                },
                // {
                //     title: 'trem.lang.home.0916', // 갤러리
                //     route: `/home/board/gallery/list`,
                // },
            ],
        },
        // {
        //     title: 'trem.lang.home.0399', //서울바이오허브
        //     menus: [
        //         {
        //             title: 'trem.lang.home.0398', //시설안내
        //             route: `/location/main`,
        //             menus: [
        //                 {
        //                     title: 'trem.lang.home.0399', //서울바이오허브
        //                     route: `/location/main`,
        //                 },
        //                 {
        //                     title: 'trem.lang.home.0416', //서울바이오 혁신커뮤니티센터
        //                     route: `/location/community`,
        //                 },
        //                 {
        //                     title: 'trem.lang.home.0427', //서울 바이오 산학협력센터
        //                     route: `/location/cooperation`,
        //                 },
        //                 {
        //                     title: 'trem.lang.home.0431', //BT-IT융합센터
        //                     route: `/location/btit`,
        //                 },
                       
        //             ],
        //         },
        //         {
        //             title: 'trem.lang.home.0695', //주요지원사업
        //             route: `https://www.seoulbiohub.kr/front/supportManageReq/supportManageListPage.do`,
        //         },
        //         {
        //             title: `trem.lang.home.0469`, //유관기관
        //             route: `/home/equipRoom/list`,
        //         },
        //     ],
        // },
    ],
    operation: [
        {
            title: '장비관련업무', //장비관련업무
            menus: [
                {
                    title: '장비관리', //장비관리
                    menus: [
                        // {
                        //     title: '장비 검색', //장비 검색
                        //     route: `/search/`,
                        // },
                        // {
                        //     title: '장비 예약', //장비 예약
                        //     route: `/equipment/reservation/`,
                        // },
                        // {
                        //     title: '장비 상세', //장비 상세
                        //     route: `/equipment/equipBrief/`,
                        // },
                        // {
                        //     title: '예약관리', //예약관리
                        //     route: `/equipment/reservationMgr/`,
                        // },
                    ],
                },
                {
                    title: '업무관리', //업무관리
                    menus: [
                        // {
                        //     title: '출입카드관리', //출입카드관리
                        //     route: '/operation/accessCard',
                        // },
                    ],
                },
                {
                    title: '교육 및 시설이용', //교육 및 시설이용
                    menus: [
                        // {
                        //     title: '룸 작업', //룸 작업
                        //     route: `/field/roomWork`,
                        // },
                    ],
                },
            ],
        },

        {
            title: '서비스관리', //서비스관리
            menus: [
                {
                    title: '공지사항', //공지사항
                    menus: [
                        // {
                        //     title: `공지사항`, //공지사항
                        //     route: `/board/notice/noticeList`,
                        // },
                    ],
                },

                {
                    title: '홈페이지관리', //홈페이지관리
                    menus: [
                        // {
                        //     title: '회원관리', //회원관리
                        //     route: '/system/user',
                        // },
                    ],
                },
            ],
        },
        {
            title: '일반', //일반
            menus: [
                // {
                //     title: '사용자 정보', //사용자 정보
                //     menus: [
                //         {
                //             title: '룸 작업', //룸 작업
                //             route: `/field/roomWork`,
                //         },
                //     ],
                // },
                // {
                //     title: 'Floor 사용법', //Floor 사용법
                //     menus: [
                //         {
                //             title: '버튼 등 사용법', //버튼 등 사용법
                //             route: `/usage/buttonUsage/`,
                //         },
                //         {
                //             title: '다이알로그 사용법', //다이알로그 사용법
                //             route: `/usage/dialogPage/`,
                //         },
                //         {
                //             title: 'API 호출', //API 호출
                //             route: `/usage/usageApiCallPage`,
                //         },
                //         {
                //             title: '입력컨트롤', //입력컨트롤
                //             route: `/usage/inputCtrlUsage/`,
                //         },
                //         {
                //             title: '기본입력컨트롤', //기본입력컨트롤
                //             route: `/usage/inputCtrlUsageSimple/`,
                //         },
                //         {
                //             title: '상세페이지 샘플', //상세페이지 샘플
                //             route: `/usage/detailPage/`,
                //         },
                //         {
                //             title: 'DataGrid 사용법', //DataGrid 사용법
                //             route: `/usage/dataGridUsage/`,
                //         },
                //         {
                //             title: 'table', //table
                //             route: `/usage/tablePage/`,
                //         },
                //         {
                //             title: '문서 생성기', //문서 생성기
                //             route: `/system/docgen/`,
                //         },
                //         {
                //             title: '반응형웹 샘플', //반응형웹 샘플
                //             route: `/usage/ui/`,
                //         },
                //         {
                //             title: '테스트 페이지', //테스트 페이지
                //             route: `/newPage/`,
                //         },
                //     ],
                // },
            ],
        },
    ],
}
